import 'jquery';
import 'bootstrap';
import 'slick-carousel';
import 'jquery-parallax.js';

require('./components/menu');
require('./components/main');

$(document).ready(function() {
	 $('.slider-home').slick({
    rows: 2,
 	infinite: true,
  	slidesToShow: 5,
  	slidesToScroll: 1,
     autoplay:true,
      autoplaySpeed:1500,
      arrows:true,
    prevArrow:'<button type="button" class="slick-prev"></button>',
  nextArrow:'<button type="button" class="slick-next"></button>',


  	  responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }

  ],

////
 });	
	});


// WEBPACK FOOTER //
// ./resources/assets/scripts/app.js